import { API_URL } from "../../../constants";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { EntityManagement } from "../../../components";
import {
  MedicationRemarkForm,
  initialValues,
  validationSchema,
} from "./form/MedicationRemarkForm";
import { PageHeader } from "../../../components/PageHeader";
import AddCircleOutlinedIcon from "@material-ui/icons/AddCircleOutlined";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import Tooltip from "@material-ui/core/Tooltip";

const MedicationRemarkPageHeader = (props) => {
  const { setCreating, clearNotification } = props;

  return (
    <PageHeader title="服用備註">
      <Button
        variant="contained"
        color="primary"
        startIcon={<AddCircleOutlinedIcon />}
        onClick={() => {
          clearNotification();
          setCreating(true);
        }}
      >
        新增服用備註
      </Button>
    </PageHeader>
  );
};

export default function MedicationRemark() {
  const home = useSelector((state) => state.home);
  const [apiUrl, setApiUrl] = useState({});

  const createParams = (values, coreCreateParams) => {
    let params = {};
    params = coreCreateParams(values);

    return params;
  };

  const getColumnSettings = (props) => {
    const {
      setEditingEntity,
      setDeletingEntity,
      setCopyEntity,
      clearNotification,
      loading,
    } = props;

    return [
      {
        field: "action",
        headerName: "動作",
        width: 150,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          return (
            <div>
              <Tooltip title="修改">
                <IconButton
                  color="default"
                  size="small"
                  onClick={() => {
                    clearNotification();
                    setEditingEntity(params.row);
                  }}
                  disabled={loading}
                >
                  <EditOutlinedIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="刪除">
                <IconButton
                  color="default"
                  size="small"
                  onClick={() => {
                    clearNotification();
                    setDeletingEntity(params.row);
                  }}
                  disabled={loading}
                >
                  <DeleteOutlinedIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="另存">
                <IconButton
                  color="default"
                  size="small"
                  onClick={() => {
                    clearNotification();
                    setCopyEntity(params.row);
                  }}
                  disabled={loading}
                >
                  <FileCopyOutlinedIcon />
                </IconButton>
              </Tooltip>
            </div>
          );
        },
      },
      {
        field: "nameTc",
        headerName: "服用備註",
        width: 1000,
        sortable: false,
        filterable: false,
        renderCell: function (params) {
          return params.row[params.field];
        },
      },
    ];
  };

  useEffect(() => {
    setApiUrl({
      getAll: API_URL.MEDICINE_TAKING_REMARKS,
      getOne: API_URL.MEDICINE_TAKING_REMARKS,
      create: API_URL.MEDICINE_TAKING_REMARKS,
      edit: API_URL.MEDICINE_TAKING_REMARKS,
      delete: API_URL.MEDICINE_TAKING_REMARKS,
      copy: API_URL.MEDICINE_TAKING_REMARKS,
    });
  }, [home]);

  return (
    <EntityManagement
      entityModel="服用備註"
      editableFields={["nameTc", "name"]}
      getColumnSettings={getColumnSettings}
      createParams={createParams}
      apiUrl={apiUrl}
      dataInputForm={MedicationRemarkForm}
      initialValues={initialValues}
      validationSchema={validationSchema}
      maxWidth="sm"
      pageHeader={MedicationRemarkPageHeader}
    ></EntityManagement>
  );
}
